export default __webpack_public_path__ + "assets/images/thumbnail-axial.png";